<template>
  <div class="w-full h-screen">
    <p class="text-brand uppercase font-medium p-4 pt-8">Vault Settings</p>
    <ul class="w-full">
      <div v-if="$route.params.vault_id != undefined">
        <li
          class="font-semibold text-grey-darker uppercase py-2 px-4"
          v-is-authorized="{ roles: [role], permissions: ['can_manage_roles_restrictions', 'can_view_members', 'can_add_members'] }"
        >Manage Users/Permissions</li>
        <li
          class="group hover:border-t hover:border-b hover:border-grey-light hover:bg-white"
          v-is-authorized="{ roles: [role], permissions: ['can_add_members'] }"
        >
          <router-link
            :to="{name:'invite-members', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-grey-dark no-underline py-2 px-4 w-full block hover:bg-white hover:border-l-4 hover:border-brand text-sm"
            active-class="bg-white border-l-4 border-brand"
            @click.native="closeSettings()"
          >Invite New Members</router-link>
        </li>
        <li
          class="group hover:border-t hover:border-b hover:border-grey-light hover:bg-white"
          v-is-authorized="{ roles: [role], permissions: ['can_view_members'] }"
        >
          <router-link
            :to="{name: 'add-delete-members', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-grey-dark no-underline py-2 px-4 w-full block hover:bg-white hover:border-l-4 hover:border-brand text-sm"
            active-class="bg-white border-l-4 border-brand"
            @click.native="closeSettings()"
          >Edit/Delete members</router-link>
        </li>
        <li
          class="group hover:border-t hover:border-b hover:border-grey-light hover:bg-white"
          v-is-authorized="{ roles: [role], permissions: ['can_manage_roles_restrictions'] }"
        >
          <router-link
            :to="{name: 'role-restrictions-tag', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-grey-dark no-underline py-2 px-4 w-full block hover:bg-white hover:border-l-4 hover:border-brand text-sm"
            active-class="bg-white border-l-4 border-brand"
            @click.native="closeSettings()"
          >Role Restrictions per Tag</router-link>
        </li>
      </div>

      <div v-is-authorized="{ roles: [role], permissions: ['can_access_billing_invoicing'] }">
        <li class="font-medium text-grey-darker uppercase py-2 px-4 mt-6">Billing &amp; Account</li>
        <li class="group hover:border-grey hover:border hover:border-r-0 hover:border-l-0">
          <router-link
            :to="{name: 'subscription', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-grey-dark no-underline py-2 px-4 w-full block hover:bg-white hover:border-l-4 hover:border-brand text-sm"
            active-class="bg-white border-l-4 border-brand border-grey border-r-0 border-l-0"
            @click.native="closeSettings()"
          >Subscription and Invoices</router-link>
        </li>
        <li class="group hover:border-grey hover:border hover:border-r-0 hover:border-l-0">
          <router-link
            :to="{name: 'change-plan', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-grey-dark no-underline py-2 px-4 w-full block hover:bg-white hover:border-l-4 hover:border-brand text-sm"
            active-class="bg-white border-l-4 border-brand border-grey border-r-0 border-l-0"
            @click.native="closeSettings()"
          >Change Plan</router-link>
        </li>
        <li class="group hover:border-grey hover:border hover:border-r-0 hover:border-l-0">
          <router-link
            :to="{name: 'update-billing-details', params: {vault_id: $route.params.vault_id}}"
            class="font-medium text-grey-dark no-underline py-2 px-4 w-full block hover:bg-white hover:border-l-4 hover:border-brand text-sm"
            active-class="bg-white border-l-4 border-brand border-grey border-r-0 border-l-0"
            @click.native="closeSettings()"
          >Update Billing Details</router-link>
        </li>
      </div>

      <li class="font-semibold text-grey-darker uppercase py-2 px-4 mt-6">About the Vault</li>
      <li class="group hover:border-t hover:border-b hover:border-grey-light hover:bg-white">
        <router-link
          :to="{name: 'vault-details', params: {vault_id: $route.params.vault_id}}"
          class="font-medium text-grey-dark no-underline py-2 px-4 w-full block hover:bg-white hover:border-l-4 hover:border-brand text-sm"
          active-class="bg-white border-l-4"
          @click.native="closeSettings()"
        >Vault Details</router-link>
      </li>

      <li
        class="group hover:border-t hover:border-b hover:border-grey-light hover:bg-white"
        v-is-authorized="{ roles: [role], permissions: ['can_transfer_ownership'] }"
      >
        <router-link
          :to="{name: 'transfer-ownership', params: {vault_id: $route.params.vault_id}}"
          class="font-medium text-grey-dark no-underline py-2 px-4 w-full block hover:bg-white hover:border-l-4 hover:border-brand text-sm"
          active-class="bg-white border-l-4"
          @click.native="closeSettings()"
        >Transfer Ownership</router-link>
      </li>

      <li
        class="group hover:border-t hover:border-b hover:border-grey-light hover:bg-white"
        v-is-authorized="{ roles: [role], permissions: ['can_manage_tags'] }"
        v-if="is_enabled"
      >
        <router-link
          :to="{name: 'manage-tags', params: {vault_id: $route.params.vault_id}}"
          class="font-medium text-grey-dark no-underline py-2 px-4 w-full block hover:bg-white hover:border-l-4 hover:border-brand text-sm"
          active-class="bg-white border-l-4"
          @click.native="closeSettings()"
        >Manage Tags</router-link>
      </li>
    </ul>

    <sweet-modal
      icon="warning"
      ref="not_available"
      overlay-theme="dark"
    >This feature is not yet available</sweet-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  methods: {
    closeSettings() {
      this.$emit("close-settings");
    },
    openNotAvailable() {
      this.$emit("not-available");
    }
  },

  computed: {
    ...mapGetters({
      role: "getUserRole"
    }),

    is_enabled() {
      return window.enable_tag_editing;
    }
  }
};
</script>

<style>
</style>
